<template>
  <div class="contents contents--pt">
    <section class="Form _min-h">
      <div class="inner">
        <h1>Forbidden</h1>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Page403'
}
</script>
